module.exports = __webpack_public_path__ + "static/media/hgv.cc55ed26.png";